import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "@store/hooks";
import { clearAll } from "@store/slices/authSlice";

const BANNER_BG = "#8a3500";
const BANNER_FG = "#ffffff";

const DemoBanner = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const goToLanding = () => {
    dispatch(clearAll());
    navigate("/");
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        px: 2,
        py: 0.5,
        bgcolor: BANNER_BG,
        color: BANNER_FG,
        fontSize: "0.875rem",
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 500, color: BANNER_FG }}>
        Demo mode — changes are not saved
      </Typography>
      <Button
        size="small"
        variant="contained"
        onClick={goToLanding}
        sx={{
          py: 0,
          minHeight: 0,
          lineHeight: 1.5,
          "&&": { bgcolor: BANNER_FG, color: BANNER_BG },
          "&&:hover": { bgcolor: "#f0f0f0", color: BANNER_BG },
        }}
      >
        Sign up to save
      </Button>
      <Button
        size="small"
        variant="text"
        onClick={goToLanding}
        sx={{
          py: 0,
          minHeight: 0,
          lineHeight: 1.5,
          textDecoration: "underline",
          "&&": { color: BANNER_FG },
          "&&:hover": { color: BANNER_FG, bgcolor: "rgba(255, 255, 255, 0.12)" },
        }}
      >
        Sign in
      </Button>
    </Box>
  );
};

export default DemoBanner;
